<script>
  export let isReverse = false;
</script>

<svg
  class={isReverse ? 'reverse' : ''}
  width="12"
  height="7"
  viewBox="0 0 12 7"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1 1L6 6L11 1"
    stroke="var(--vlt-lp-primary);"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<style>
  .reverse {
    transform: scale(1, -1);
  }
</style>
